import React, { useState } from 'react';

import { JRCHtml } from 'components/JRCHtml/JRCHtml';

import { WidgetDatasourceValues, WidgetTableColumnsData } from 'jamespot-user-api';

import { ensureIsStringOrNumber } from './ensure';

import { CSSReadMoreGradient, CSSReadMoreWrapper } from './JRCWidgetTable.styles';

export const JRCWidgetTableTdRendererText = ({
    value,
    name,
    backgroundColor = '#fff',
    tableColumnsData,
}: {
    name: string;
    tableColumnsData: WidgetTableColumnsData;
    backgroundColor: string;
    value: WidgetDatasourceValues;
}) => {
    const [isHidden, setIsHidden] = useState<boolean>(true);
    const columnData = tableColumnsData?.find((el) => el.name === name);
    if (ensureIsStringOrNumber(value)) {
        return columnData?.textEllipsis && isHidden ? (
            <>
                <CSSReadMoreWrapper onClick={() => setIsHidden(false)}>
                    <JRCHtml __html={String(value)} />
                </CSSReadMoreWrapper>
                <CSSReadMoreGradient backgroundColor={backgroundColor} onClick={() => setIsHidden(false)} />
            </>
        ) : (
            <JRCHtml __html={String(value)} />
        );
    }

    return <></>;
};
